import React, { useState, useEffect } from "react";
import "./index.scss";
import { Input, Button, message, Radio } from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import logo from "./../../assets/kuaifu.svg";
import md5 from "js-md5";
import {
  login,
  login_phone,
  phone_login,
  accountLoginChose,
} from "../../api/login";
import axios from "axios";
// import qs from "querystring";
// const qs = require('querystring');

//节流函数
// import _ from "lodash";

const Login = (props) => {
  const [phone_loading, Setphone_loading] = useState(false),
    [time_test, Settime_test] = useState(undefined),
    [phone_none, Setphone_none] = useState(false),
    [login_loading, Setlogin_loading] = useState(false),
    [yzm_color, Setyzm_color] = useState(false),
    [password_color, Setpassword_color] = useState(false),
    [account_color, Setaccount_color] = useState(false),
    [password_true, Setpassword_true] = useState(false), //密码错误多次
    [password_one, Setpassword_one] = useState(false), //密码错误一次
    [account_true, Setaccount_true] = useState(false), //账号不存在
    [token, Settoken] = useState(""),
    [accounts, Setaccounts] = useState(""),
    [radioValue, SetradioValue] = useState(0),
    [account_number, Setaccount_number] = useState(false),
    [accountList, SetaccountList] = useState([]),
    [yzm, Setyzm] = useState(undefined), //验证码
    [count_ture, Setcount_ture] = useState(false),
    [count, Setcount] = useState(undefined),
    [phone_number, Setphone_number] = useState(""), //手机号
    [loginType, SetloginType] = useState(false), //登录方式
    [warningText, SetwarningText] = useState(""), //提示文字
    [account, Setaccount] = useState(""), //账户
    [password, Setpassword] = useState(""); //密码
  let password_modification_timer;
  let test_timer;

  //去注册
  function goRegister() {
    props.history.push("/create_account");
    // window.location.href = "https://shop.71baomu.com/Account/reg";
  }
  //找回密码
  function goFindPassword() {
    props.history.push("/find_password");
  }
  useEffect(() => {
    if (loginType) {
      document.getElementById("yzmBtn").disabled = "disabled";
      var reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (phone_number.length === 11) {
        if (!reg.test(phone_number)) {
          document.getElementById("yzmBtn").disabled = "disabled";
        } else {
          document.getElementById("yzmBtn").disabled = "";
        }
      } else {
        if (document.getElementById("yzmBtn")) {
          document.getElementById("yzmBtn").disabled = "disabled";
        }
      }
    }
  }, [loginType]);
  //切换手机号登录
  function changeLogin() {
    SetloginType(!loginType);
    SetwarningText(undefined);
    Setaccount_color(false);
    Setyzm_color(false);
    Setpassword_color(false);
    Setphone_none(false);
    Setaccount_true(false);
    Setpassword_true(false);
    // count_down();
    console.log(phone_number);
    if (count !== undefined) {
      count_down();
    }
  }
  //登录
  async function goLogin() {
    if (!loginType) {
      if (!account && !password) {
        SetwarningText("账号和密码未填写");
        Setaccount_color(true);
        Setpassword_color(true);
        return;
      }
      if (!account) {
        SetwarningText("账户未填写");
        Setaccount_color(true);
        return;
      }
      if (!password) {
        SetwarningText("密码未填写");
        Setpassword_color(true);
        return;
      }
      Setlogin_loading(true);
      let mdPassword = md5(password);
      let data = {
        account,
        password: mdPassword,
      };
      await Setaccount_true(false);
      await Setpassword_true(false);
      let login_result = await login(data);
      console.log(login_result);
      if (login_result.code === 200) {
        Setlogin_loading(false);
        window.location.href = login_result.data;
      } else {
        Setlogin_loading(false);
        if (login_result.code === 404) {
          Setaccount_true(true);
          Setaccount_color(true);
        } else {
          if (login_result.code === 406) {
            Setpassword_color(true);
            Setaccount_color(true);
            SetwarningText(login_result.message);
          } else {
            if (login_result.code === 403) {
              Setpassword_color(true);
              Setpassword_true(true);
            } else {
              if (login_result.code === 503) {
                Setpassword_color(true);
                Setaccount_color(true);
                SetwarningText(login_result.msg);
              } else {
                if (login_result.code === 512) {
                  Setpassword_color(true);
                  Setaccount_color(true);
                  SetwarningText(login_result.msg);
                } else {
                  if (login_result.code === 514) {
                    SetwarningText(login_result.message);
                  } else {
                    SetwarningText(login_result.message);
                    Setaccount_color(true);
                  }
                }
              }
            }
          }
        }
      }
      // window.location.href = login(data);
    } else {
      if (
        (yzm === "" || yzm === undefined) &&
        (phone_number === undefined || phone_number === "")
      ) {
        SetwarningText("手机号和验证码未填写");
        Setaccount_color(true);
        Setyzm_color(true);
        return;
      }
      var reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (phone_number.length !== 11 || !reg.test(phone_number)) {
        SetwarningText("手机号格式错误");
        Setaccount_color(true);
        return;
      }
      if (phone_number === undefined || phone_number === "") {
        SetwarningText("手机号未填写");
        Setaccount_color(true);
        return;
      }
      if (yzm === "" || yzm === undefined) {
        SetwarningText("验证码未填写");
        Setyzm_color(true);
      } else {
        let data = {
          phone: phone_number,
          code: yzm,
        };
        Setlogin_loading(true);
        let phoneLogin = await phone_login(data);
        console.log(phoneLogin);
        if (phoneLogin.code === 201) {
          Setlogin_loading(false);
          SetaccountList(phoneLogin.data.worklist);
          Settoken(phoneLogin.data.token);
          // console.log(phoneLogin.data.WorkList);
          if (phoneLogin.data.worklist.length === 1) {
            let datas = {
              account: phoneLogin.data.worklist[0].account,
              token: phoneLogin.data.token,
            };
            let loginFinish = await accountLoginChose(datas);
            if (loginFinish.code === 200) {
              window.location.href = loginFinish.data;
            } else {
              if (loginFinish.code === 505) {
                SetwarningText("账号已离职");
                Setaccount_color(true);
              }
            }
            console.log(loginFinish);
          } else {
            if (phoneLogin.data.worklist.length === 0) {
              Setaccount_color(true);
              SetwarningText("手机账号不存在");
            } else {
              Setaccount_number(true);
            }
          }
        } else {
          if (phoneLogin.code === 406) {
            Setyzm_color(true);
          }
          Setlogin_loading(false);
          SetwarningText(phoneLogin.message);
        }
      }
    }
  }
  //手机号填写
  function change_phone(e) {
    Setphone_number(e.target.value);
    // document.getElementById("codeBtn").disabled = "disabled";
  }
  useEffect(() => {
    var reg =
      /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    if (phone_number.length === 11) {
      if (!reg.test(phone_number)) {
        document.getElementById("yzmBtn").disabled = "disabled";
      } else {
        document.getElementById("yzmBtn").disabled = "";
      }
    } else {
      if (document.getElementById("yzmBtn")) {
        document.getElementById("yzmBtn").disabled = "disabled";
      }
    }
  }, [phone_number]);
  //验证码填写
  function change_yzm(e) {
    Setyzm(e.target.value);
  }
  //发送验证码
  function send_code() {
    if (loginType) {
      if (phone_number === "" || phone_number === undefined) {
        SetwarningText("手机号未填写");
        Setaccount_color(true);
      } else {
        document.getElementById("yzmBtn").disabled = "disabled";
        // count_down()
        getmessage();
      }
    }
  }
  async function getmessage() {
    const datas = {
      worker: phone_number,
      type: "phone",
    };
    let getVerification = await login_phone(datas);
    console.log(getVerification);
    if (getVerification.code === 201) {
      // document.getElementById("yzmBtn").style.backgroundColor = "#f5f5f5";
      count_down();
      count_d();
      document.getElementById("yzmBtn").style.backgroundColor = "#f5f5f5";
    } else {
      document.getElementById("yzmBtn").disabled = "";
      if (getVerification.code === 406) {
        Setyzm_color(true);
        SetwarningText(getVerification.message);
      } else {
        if (getVerification.code === 416 || getVerification.code === 417) {
          Setaccount_color(true);
          Setphone_none(true);
        } else {
          Setyzm_color(true);
          SetwarningText(getVerification.message);
        }
      }

      // message.error(getVerification.message);
      // Setphone_number("");
    }
  }
  function count_d() {
    var num = 60;
    test_timer = setInterval(() => {
      if (document.getElementById("test") !== null) {
        if (num <= 0) {
          clearInterval(test_timer);
          Settime_test(0);
        } else {
          num = num - 1;
          Settime_test(num);
        }
      } else {
        clearInterval(test_timer);
        Settime_test(undefined);
      }
    }, 1000);
  }
  //倒计时
  function count_down() {
    if (count === undefined) {
      var counts = 60;
    } else {
      if (time_test === undefined) {
        var counts = 60;
      } else {
        if (time_test === 0) {
          var counts = 0;
          document.getElementById("yzmBtn").style.backgroundColor = "#ffffff";
          document.getElementById("yzmBtn").disabled = "";
          Setcount(undefined);
        } else {
          var counts = time_test;
        }
      }
    }

    // var count = 60;
    password_modification_timer = setInterval(() => {
      if (document.getElementById("yzmBtn") !== null) {
        if (counts <= 0) {
          clearInterval(password_modification_timer);
          Setcount(undefined);
          document.getElementById("yzmBtn").style.backgroundColor = "#ffffff";
          document.getElementById("yzmBtn").disabled = "";
        } else {
          counts = counts - 1;
          document.getElementById("yzmBtn").disabled = "disabled";
          document.getElementById("yzmBtn").style.backgroundColor = "#f5f5f5";
          Setcount(counts);
          Setcount_ture(true);
          console.log(1111);
        }
      } else {
        clearInterval(password_modification_timer);
      }
    }, 1000);
  }
  //账号选择
  function radioChange(e) {
    Setaccounts(accountList[e.target.value].account);
    SetradioValue(e.target.value);
  }
  //回短信登录
  function goPhoneLogin() {
    if (count !== undefined) {
      count_down();
    }
    Setaccount_number(false);
    SetwarningText(undefined);
  }
  //短信选择账号登录
  async function goAccountTrue() {
    Setphone_loading(true);
    let data = {
      account: accounts || accountList[0].account,
      token: token,
    };
    let loginPhoneFinish = await accountLoginChose(data);
    // console.log(data);
    if (loginPhoneFinish.code === 200) {
      window.location.href = loginPhoneFinish.data;
      Setphone_loading(false);
    } else {
      Setphone_loading(false);
      if (loginPhoneFinish.code === 505) {
        message.error("账号已停职");
        Setphone_loading(false);
      }
    }
  }
  return (
    <div className="login">
      <div className="loginText" id="test">
        <p>
          服务不止于快<span>快服为企业成长助一臂之力</span>
        </p>
      </div>
      <div>
        {account_number ? (
          <div className="login_account">
            <div className="choseAccountTiltle">选择登录账号</div>
            <div className="choseAccountTip">
              该手机号绑定了多个账户，请选择要登录的账户
            </div>
            <div className="choseAccountMain" onClick={goPhoneLogin}>
              <LeftOutlined className="choseAccountMainImg" />
              <div className="choseAccountMainFent">{phone_number}</div>
            </div>
            <div className="accountList">
              <div style={{ width: 448 }} className="accountBigBox">
                <Radio.Group onChange={radioChange} value={radioValue}>
                  {accountList.map((ele, index) => {
                    return (
                      <div className="accountListBox">
                        <div className="accountListLeft">
                          <img src={logo} className="accountListImg"></img>
                          <div
                            className={`accountListFent ${
                              radioValue === index ? "active" : ""
                            }`}
                          >
                            <div className="accountListFentTop">
                              {ele.name === null ? ele.account : ele.name}
                            </div>
                            <div className="accountListFentBottom">
                              {ele.account}
                            </div>
                          </div>
                        </div>
                        <Radio value={index}></Radio>
                      </div>
                    );
                  })}
                </Radio.Group>
              </div>
            </div>
            <Button
              className="accountBtn"
              onClick={goAccountTrue}
              loading={phone_loading}
            >
              {phone_loading ? "登录中" : "登录"}
            </Button>
          </div>
        ) : (
          <div className="loginInputArea">
            <p className="loginTitle">登录快服网</p>
            <p className="warningText" style={{ display: "" }}>
              {account_true && !loginType ? (
                <div>
                  该账户不存在，请输入其他账户或
                  <span
                    onClick={goRegister}
                    style={{
                      marginLeft: 8,
                      color: "#0471E3",
                      cursor: "pointer",
                    }}
                  >
                    获取新账户
                  </span>
                </div>
              ) : password_true && !loginType ? (
                <div>
                  您已连续三次登录错误，请在2分钟后重试！或
                  <span
                    onClick={goFindPassword}
                    style={{
                      marginLeft: 8,
                      color: "#0471E3",
                      cursor: "pointer",
                    }}
                  >
                    找回密码
                  </span>
                </div>
              ) : phone_none && loginType ? (
                <div>
                  该手机号不存在，请先
                  <span
                    onClick={goRegister}
                    style={{
                      marginLeft: 8,
                      color: "#0471E3",
                      cursor: "pointer",
                    }}
                  >
                    注册账号
                  </span>
                </div>
              ) : (
                <div>{warningText}</div>
              )}
            </p>
            <p className="changeLoginType" onClick={changeLogin}>
              {loginType ? "账号密码登录" : "短信快捷登录"}
              <RightOutlined />
            </p>
            {loginType ? (
              <div className="accountPassword">
                <div>
                  <p className="accountArea">
                    <Input
                      placeholder="手机号"
                      // className="accountAreaInput"
                      className={`accountAreaInput ${
                        account_color === true ? "actives" : ""
                      }`}
                      onFocus={() => {
                        SetwarningText(undefined);
                        Setaccount_color(false);
                        Setyzm_color(false);
                        Setaccount_true(false);
                        Setpassword_true(false);
                        Setphone_none(false);
                      }}
                      value={phone_number}
                      onChange={change_phone}
                    />
                  </p>
                  <p className="verifyArea">
                    <div className="verifyNumArea">
                      <Input
                        placeholder="验证码"
                        // className="verifyNumAreaInput"
                        className={`verifyNumAreaInput ${
                          yzm_color === true ? "actives" : ""
                        }`}
                        onFocus={() => {
                          SetwarningText(undefined);
                          Setaccount_color(false);
                          Setyzm_color(false);
                          Setaccount_true(false);
                          Setpassword_true(false);
                          Setphone_none(false);
                        }}
                        value={yzm}
                        onChange={change_yzm}
                      />
                    </div>
                    <Button
                      className="verifyButton"
                      id="yzmBtn"
                      onClick={send_code}
                    >
                      {count
                        ? count + "s"
                        : count_ture === true
                        ? "重新发送"
                        : "获取验证码"}
                    </Button>
                  </p>
                </div>
              </div>
            ) : (
              <div className="accountPassword">
                <div>
                  <p className="accountArea">
                    <Input
                      placeholder="账号"
                      // className="accountAreaInput"
                      className={`accountAreaInput ${
                        account_color === true ? "actives" : ""
                      }`}
                      value={account}
                      onFocus={() => {
                        Setaccount_color(false);
                        Setpassword_color(false);
                        SetwarningText(undefined);
                        Setaccount_true(false);
                        Setpassword_true(false);
                        Setphone_none(false);
                      }}
                      onChange={(e) => {
                        Setaccount(e.target.value);
                      }}
                    />
                  </p>
                  <p className="passwordArea">
                    <Input.Password
                      placeholder="密码"
                      // className="passwordAreaInput"
                      className={`passwordAreaInput ${
                        password_color === true ? "actives" : ""
                      }`}
                      valur={password}
                      onFocus={() => {
                        Setaccount_color(false);
                        Setpassword_color(false);
                        SetwarningText(undefined);
                        Setaccount_true(false);
                        Setpassword_true(false);
                        Setphone_none(false);
                      }}
                      onChange={(e) => {
                        Setpassword(e.target.value);
                      }}
                    />
                  </p>
                </div>
              </div>
            )}

            <p className="loginButtonArea">
              <Button
                className="loginButton"
                block={true}
                onClick={goLogin}
                loading={login_loading}
              >
                {login_loading ? "登录中" : "登录"}
              </Button>
            </p>
            <p className="goRegister">
              <span onClick={goRegister}>没有账户？免费注册一个！</span>
            </p>
            {!loginType ? (
              <p className="goFindPassword">
                <span onClick={goFindPassword}>忘记密码？</span>
              </p>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
